import * as angular from "angular";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ServiceAreaRequests} from "./service-area-requests.service";
import {ServiceAreasAlerts} from "./service-areas-alerts.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";

export class ServiceAreasService {

  /* @ngInject */
  constructor(private serviceAreaRequests: ServiceAreaRequests, private serviceAreasAlerts: ServiceAreasAlerts, private $q: IQService,
              private bringozLoaderService: BringozLoaderService, private commonsAlertsService: CommonsAlertsService, private $log) {
  }

  getAreasByIds(ids) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.serviceAreaRequests.getAreasByIds(ids)
      .then((serviceAreas) => {
        deferred.resolve(serviceAreas)
      })
      .catch((error) => {
        this.$log.error(error);
        this.serviceAreasAlerts.getManyError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getAll(queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.serviceAreaRequests.getAll(queryParams)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getGeoJson(queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.serviceAreaRequests.getGeoJson(queryParams)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportGeoJson(queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.serviceAreaRequests.exportGeoJson(queryParams)
      .then(() => {
        this.commonsAlertsService.exportToMailSuccess();
        deferred.resolve();
      })
      .catch((error) => {
        this.$log.error(error);
        this.commonsAlertsService.exportToMailError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportKml(queryParams) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.serviceAreaRequests.exportKml(queryParams)
      .then(() => {
        this.commonsAlertsService.exportToMailSuccess();
        deferred.resolve();
      })
      .catch((error) => {
        this.$log.error(error);
        this.commonsAlertsService.exportToMailError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.service-areas')
  .service('serviceAreasService', ServiceAreasService);
